import styled from 'styled-components';

export const NotificationsHolder = styled.div`
  width: 100%;
  max-width: 400px;
  max-height: 400px;
  text-align: left;
  padding: 20px;
  border-radius: 10px;
  background: var(--white);
  overflow: hidden;

  .scroll-area {
    overflow: auto;
    height: 250px;
    padding: 0 5px 0 0;
    margin: 0 0 10px;
    scroll-behavior: smooth;
  }

  .holder {
    max-width: 432px;
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid var(--gray-50);
    margin-bottom: 15px;

    &:nth-child(1) {
      padding-top: 0;
    }
    &:nth-last-child(1) {
      border: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    .heading {
      font-size: 20px;
      line-height: 24px;
      text-transform: capitalize;
      font-weight: 700;
      color: var(--text-color-50);
      margin: 0;
    }
  }

  .content-box {
    width: 100%;
    color: var(--text-color-50);
    padding: 0 0 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(157, 157, 157, 0.2);

    .title-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 5px;
      font-size: 15px;
      line-height: 18px;

      .title {
        font-style: italic;
        font-weight: 700;
      }

      .tag {
        display: block;
        font-size: 12px;
        line-height: 16px;
        padding: 3px 10px;
        text-align: center;
        color: #419400;
        border-radius: 5px;
        background: rgba(65, 148, 0, 0.1);
      }
    }

    .text-box {
      position: relative;
      padding: 0 0 0 8px;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 3px;
        background: #419400;
        border-radius: 0 10px 10px 0;
      }
    }
  }

  .mark-read {
    display: block;
    font-size: 14px;
    line-height: 18px;
    color: #3ea49d;
    cursor: pointer;

    &.loading,
    &.all-read {
      cursor: not-allowed;
    }

    &.all-read {
      opacity: 0.5;
    }
  }
`;
export const ImageHolder = styled.div`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ background }) => background && background};
`;

export const StyledProfileDropDown = styled.div`
  padding: 30px 10px 15px;
  background: red;
  border-radius: 0 0 10px 10px;
  background: #efefef;
  overflow: hidden;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: var(--primary);

  .plane-btn {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .credits-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    p {
      margin-bottom: 0;
    }
  }
  .planeprogress {
    background: linear-gradient(90deg, rgba(39, 131, 236, 0.1) 0%, rgba(30, 220, 227, 0.1) 100%);
    height: 5px;
    border-radius: 10px;
    width: 100%;
    position: relative;
    overflow: hidden;
    margin-bottom: 15px;
    &::before {
      position: absolute;
      content: '';
      top: 0;
      bottom: 0;
      left: 0;
      width: var(--value);
      background: linear-gradient(180deg, #1edce3 0%, #2783ec 100%);
      border-radius: 15px;
    }
  }
  .links-wrap {
    li {
      width: 100%;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      .wrap {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .img-wrap {
        max-width: 18px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .plan-type {
        padding: 5px;
        border-radius: 3px;
        background: var(--white);
      }
    }
  }
  .logout {
    color: #ff4b26;
    padding-top: 10px;
    position: relative;
    cursor: pointer;
    &::before {
      position: absolute;
      content: '';
      left: -15px;
      right: -15px;
      height: 2px;
      background: var(--white);
      top: 0;
    }
    li {
      margin-bottom: 0;
    }
  }
`;
